'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ObjectHelper = require('../common/ObjectHelper.js');

function calculateDiscountAmount(discounts, subtotal) {
  var dollarDiscountInHundredths;
  var percentDiscountInHundredths;

  if (ObjectHelper.isPresent(discounts.fixed_discounts)) {
    dollarDiscountInHundredths = discounts.fixed_discounts.reduce(function (accumulatedDiscount, currentFixedDiscount) {
      return accumulatedDiscount + currentFixedDiscount.amount;
    }, 0);
  } else if (ObjectHelper.isPresent(discounts.percentage_discount)) {
    percentDiscountInHundredths = discounts.percentage_discount.percent;
  }

  return calculateDiscountAmountFromDiscountValues(dollarDiscountInHundredths, percentDiscountInHundredths, subtotal);
}

function calculateDiscountAmountFromDiscountValues(dollarDiscountInHundredths, percentDiscountInHundredths, subtotal) {
  var discountAmount = 0;

  if (ObjectHelper.isPresent(dollarDiscountInHundredths)) {
    discountAmount = dollarDiscountInHundredths;
  } else if (ObjectHelper.isPresent(percentDiscountInHundredths)) {
    var exactCalculatedResult = percentDiscountInHundredths / 10000.0 * subtotal;
    discountAmount = parseFloat(exactCalculatedResult.toFixed(0));
  }

  return discountAmount;
}

exports.calculateDiscountAmount = calculateDiscountAmount;
